"use client";
import { LazoPaths } from "@/enums/LazoPaths";
import { NavigateFunction, NavigateOptions } from "react-router-dom";
import Project from "../models/Project";

export enum LazoRoutes {
  UNAUTHORIZED = "UNAUTHORIZED",
  REGISTER = "REGISTER",
  PROJECT_DETAIL = "PROJECT_DETAIL",
  USER_MANAGEMENT = "USER_MANAGEMENT",
  DASHBOARD = "DASHBOARD",
  DASHBOARD_SELECT = "DASHBOARD_SELECT",
  DASHBOARD_DETAILS = "DASHBOARD_DETAILS",
  ONBOARDING = "ONBOARDING",
  REGISTER_USER_FOR_COMPANY = "REGISTER_USER_FOR_COMPANY",
  INTEGRATIONS = "INTEGRATIONS",
  LOGIN = "LOGIN",
  TERMS_AND_POLICIES = "TERMS_AND_POLICIES",
  FAQ = "FREQUENTLY_ASKED_QUESTIONS",
  COMPANY_FORM = "COMPANY_FORM",
  USER_PROFILE = "USER_PROFILE",
  LEGAL = "LEGAL",
  ADVERTISING = "ADVERTISING",
  TASKS = "TASKS",
  TASKS_ADMIN = "TASKS_ADMIN",
  NOTIFICATIONS = "NOTIFICATIONS",
  NEW_TASK = "NEW_TASK",
  TASK_DETAILS = "TASK_DETAILS",
  FUNDRAISING = "FUNDRAISING",
  FUNDRAISING_ADVANCED_SEARCH = "FUNDRAISING_ADVANCED_SEARCH",
  TAX_DEADLINES = "TAX_DEADLINES",
  TAX_TIMELINE = "TAX_TIMELINE",
  PORTAL_CUSTOMERS = "PORTAL_CUSTOMERS",
  PORTAL_NOTIFICATIONS = "PORTAL_NOTIFICATIONS",
  FUNDER_LIST_DETAIL = "FUNDER_LIST_DETAIL",
  PORTAL_CUSTOMERS_DETAILS = "PORTAL_CUSTOMERS_DETAILS",
  INVITATION_COMPANY = "INVITATION_COMPANY",
  PORTAL_INBOX = "PORTAL_INBOX",
  PORTAL_TAX_TIMELINE = "PORTAL_TAX_TIMELINE",
  ONE_SETTINGS = "ONE_SETTINGS",
  CHECKOUT = "CHECKOUT",
  ONE_COMPANY_ADD = "ONE_COMPANY_ADD",
  ONE_TASK_DETAILS = "ONE_TASK_DETAILS",
  VERIFY_EMAIL = "VERIFY_EMAIL",
  VERIFYING_EMAIL = "VERIFYING_EMAIL",
  PERSONAL_INFORMATION = "PERSONAL_INFORMATION",
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  FORGOT_PASSWORD_EMAIL_SENT = "FORGOT_PASSWORD_EMAIL_SENT",
  RESET_PASSWORD = "RESET_PASSWORD",
  NOT_SUPPORTED = "NOT_SUPPORTED",
  PRODUCT_MANAGER = "PRODUCT_MANAGER",
  PRODUCT_FLOW_TASKS = "PRODUCT_FLOW_TASKS",
  PRODUCT_FLOW_TASKS_V2 = "PRODUCT_FLOW_TASKS_V2",
  PRODUCT = "PRODUCT",
  ONE_COMMUNICATIONS = "ONE_COMMUNICATIONS",
  PORTAL_SETTINGS = "PORTAL_SETTINGS",
  ONE_DOCUMENT_CENTER = "ONE_DOCUMENT_CENTER",
  PORTAL_DOCUMENT_CENTER = "PORTAL_DOCUMENT_CENTER",
  LAZO_TEAM = "LAZO_TEAM",
  LAZO_TEAM_DETAILS = "LAZO_TEAM_DETAILS",
  PORTAL_CUSTOMERS_ACCOUNTING = "PORTAL_CUSTOMERS_ACCOUNTING",
  CSV_IMPORT_TOOL = "CSV_IMPORT_TOOL",
  ONE_DATA_ROOM = "ONE_DATA_ROOM",
  ONE_VIRTUAL_DATA_ROOMS = "ONE_VIRTUAL_DATA_ROOMS",
  ONE_DATA_ROOM_FILES = "ONE_DATA_ROOM_FILES",
  LOG_ME_AS = "LOG_ME_AS",
  ADMIN_TOOLS = "ADMIN_TOOLS",
  VIRTUAL_ROOM_ANALYTICS = "VIRTUAL_ROOM_ANALYTICS",
  ONE_VIRTUAL_DATA_ROOMS_CREATE = "ONE_VIRTUAL_DATA_ROOMS_CREATE",
  ONE_VIRTUAL_DATA_ROOMS_INSIDE = "ONE_VIRTUAL_DATA_ROOMS_INSIDE",
  SHARE_BY_LINK = "SHARE_BY_LINK",
  SHARED_VIRTUAL_DATA_ROOM = "SHARED_VIRTUAL_DATA_ROOM",
  HOME = "HOME",
  SPENDING = "SPENDING",
  ONE_SPENDING_DETAILS = "ONE_SPENDING_DETAILS",
  SIGNUP = "SIGNUP",
  SIGNUP_COUNTRY_SELECT = "SIGNUP_COUNTRY_SELECT",
  SIGNUP_COMPANY = "SIGNUP_COMPANY",
  SIGNUP_INDIVIDUAL = "SIGNUP_INDIVIDUAL",
  SIGNUP_COMPANY_INCORPORATION = "SIGNUP_COMPANY_INCORPORATION",
  SIGNUP_COMPANY_INFO = "SIGNUP_COMPANY_INFO",
  SIGNUP_ACCOUNT_TYPE = "SIGNUP_ACCOUNT_TYPE",
  SIGNUP_COMPANY_CONNECT = "SIGNUP_COMPANY_CONNECT",
  SHARED_CHECK_EMAIL = "SHARED_CHECK_EMAIL",
  ROOM_EXPIRED = "ROOM_EXPIRED",
  SHARED_FOR_LOGIN = "SHARED_FOR_LOGIN",
  ONE_VIRTUAL_DATA_ROOMS_FILE = "ONE_VIRTUAL_DATA_ROOMS_FILE",
  SHARED_VIRTUAL_DATA_ROOMS_FILE = "SHARED_VIRTUAL_DATA_ROOMS_FILE",
  VIRTUAL_DATA_ROOM_FINANCIAL_REPORT = "VIRTUAL_DATA_ROOM_FINANCIAL_REPORT",
  SHARED_VIRTUAL_DATA_ROOM_FINANCIAL_REPORT = "SHARED_VIRTUAL_DATA_ROOM_FINANCIAL_REPORT",
  REDIRECT = "REDIRECT",
  ONE_PAYWALL_ADD_BILLING_DETAILS = "PAYWALL_ADD_BILLING_DETAILS",
  ONE_PAYWALL = "PAYWALL",
  ONE_PAYWALL_CHOOSE_PLAN = "ONE_PAYWALL_CHOOSE_PLAN",
  ONE_PAYWALL_SELECT_ADD_ONS = "ONE_PAYWALL_SELECT_ADD_ONS",
  ONE_PAYWALL_CONFIRM_PURCHASE = "PAYWALL_CONFIRM_PURCHASE",
  ONE_SIGNUP = "ONE_SIGNUP",
  DOCUMENT_MANAGER = "DOCUMENT_MANAGER",
  SEARCH_AND_REPORTING = "SEARCH_AND_REPORTING",
  ORG_CHART = "ORG_CHART",
  WORKFLOW_TEMPLATES = "WORKFLOW_TEMPLATES",
  MY_SERVICES = "MY_SERVICES",
  MY_COMPANIES = "MY_COMPANIES",
  MY_SERVICES_WORKFLOW_DETAIL = "MY_SERVICES_WORKFLOW_DETAIL",
  TOOLS = "TOOLS",
  TOOLS_BATCH_EMAIL = "TOOLS_BATCH_EMAIL",
  TOOLS_BULK_DOC_UPLOAD = "TOOLS_BULK_DOC_UPLOAD",
  TOOLS_BULK_FUP = "TOOLS_BULK_FUP",
  TOOLS_CHANGE_PASSWORD = "TOOLS_CHANGE_PASSWORD",
}

export const lazoRoutesSpecification = {
  [LazoRoutes.UNAUTHORIZED]: {
    path: LazoPaths.UNAUTHORIZED,
    buildRoute: () => LazoPaths.UNAUTHORIZED,
    buildState: () => {},
  },
  [LazoRoutes.REGISTER]: {
    path: LazoPaths.REGISTER,
    buildRoute: () => LazoPaths.REGISTER,
    buildState: () => {},
  },
  [LazoRoutes.PROJECT_DETAIL]: {
    path: "/manager/project/:externalId",
    buildRoute: (params: { externalId: string }) => `/cms/content/${params.externalId}/edit`,
    buildState: (state: Project) => state,
  },
  [LazoRoutes.USER_MANAGEMENT]: {
    path: LazoPaths.USER_MANAGEMENT,
    buildRoute: () => LazoPaths.USER_MANAGEMENT,
    buildState: () => {},
  },
  [LazoRoutes.DASHBOARD]: {
    path: LazoPaths.DASHBOARD,
    buildRoute: () => LazoPaths.DASHBOARD,
    buildState: () => {},
  },
  [LazoRoutes.DASHBOARD_SELECT]: {
    path: LazoPaths.DASHBOARD_SELECTION,
    buildRoute: () => LazoPaths.DASHBOARD_SELECTION,
    buildState: () => {},
  },
  [LazoRoutes.DASHBOARD_DETAILS]: {
    path: LazoPaths.DASHBOARD_DETAILS,
    buildRoute: () => LazoPaths.DASHBOARD_DETAILS,
    buildState: () => {},
  },
  [LazoRoutes.ONBOARDING]: {
    path: LazoPaths.ONBOARDING,
    buildRoute: () => LazoPaths.ONBOARDING,
    buildState: () => {},
  },
  [LazoRoutes.INTEGRATIONS]: {
    path: LazoPaths.INTEGRATIONS,
    buildRoute: () => LazoPaths.INTEGRATIONS,
    buildState: () => {},
  },
  [LazoRoutes.LOGIN]: {
    path: LazoPaths.LOGIN,
    buildRoute: () => LazoPaths.LOGIN,
    buildState: () => {},
  },
  [LazoRoutes.TERMS_AND_POLICIES]: {
    path: LazoPaths.TERMS_AND_POLICIES,
    buildRoute: () => LazoPaths.TERMS_AND_POLICIES,
    buildState: () => {},
  },
  [LazoRoutes.FAQ]: {
    path: LazoPaths.FREQUENTLY_ASKED_QUESTIONS,
    buildRoute: () => LazoPaths.FREQUENTLY_ASKED_QUESTIONS,
    buildState: () => {},
  },
  [LazoRoutes.COMPANY_FORM]: {
    path: LazoPaths.COMPANY_FORM,
    buildRoute: () => LazoPaths.COMPANY_FORM,
    buildState: () => {},
  },
  [LazoRoutes.USER_PROFILE]: {
    path: LazoPaths.USER_PROFILE,
    buildRoute: () => LazoPaths.USER_PROFILE,
    buildState: () => {},
  },
  [LazoRoutes.LEGAL]: {
    path: LazoPaths.LEGAL,
    buildRoute: () => LazoPaths.LEGAL,
    buildState: () => {},
  },
  [LazoRoutes.ADVERTISING]: {
    path: LazoPaths.ADVERTISING,
    buildRoute: () => LazoPaths.ADVERTISING,
    buildState: () => {},
  },
  [LazoRoutes.TASKS]: {
    path: LazoPaths.TASKS,
    buildRoute: () => LazoPaths.TASKS,
    buildState: () => {},
  },
  [LazoRoutes.NOTIFICATIONS]: {
    path: LazoPaths.NOTIFICATIONS,
    buildRoute: () => LazoPaths.NOTIFICATIONS,
    buildState: () => {},
  },
  [LazoRoutes.NEW_TASK]: {
    path: LazoPaths.NEW_TASK,
    buildRoute: () => LazoPaths.NEW_TASK,
    buildState: () => {},
  },
  [LazoRoutes.TASKS_ADMIN]: {
    path: LazoPaths.TASKS_ADMIN,
    buildRoute: () => LazoPaths.TASKS_ADMIN,
    buildState: () => {},
  },
  [LazoRoutes.TASK_DETAILS]: {
    path: LazoPaths.TASK_DETAILS,
    buildRoute: () => LazoPaths.TASK_DETAILS,
    buildState: () => {},
  },
  [LazoRoutes.FUNDRAISING]: {
    path: LazoPaths.FUNDRAISING,
    buildRoute: () => LazoPaths.FUNDRAISING,
    buildState: () => {},
  },
  [LazoRoutes.FUNDRAISING_ADVANCED_SEARCH]: {
    path: LazoPaths.FUNDRAISING_ADVANCED_SEARCH,
    buildRoute: () => LazoPaths.FUNDRAISING_ADVANCED_SEARCH,
    buildState: () => {},
  },
  [LazoRoutes.TAX_DEADLINES]: {
    path: LazoPaths.TAX_DEADLINES,
    buildRoute: () => LazoPaths.TAX_DEADLINES,
    buildState: () => {},
  },
  [LazoRoutes.TAX_TIMELINE]: {
    path: LazoPaths.TAX_TIMELINE,
    buildRoute: () => LazoPaths.TAX_TIMELINE,
    buildState: () => {},
  },
  [LazoRoutes.PORTAL_CUSTOMERS]: {
    path: LazoPaths.PORTAL_CUSTOMERS,
    buildRoute: () => LazoPaths.PORTAL_CUSTOMERS,
    buildState: () => {},
  },
  [LazoRoutes.PORTAL_NOTIFICATIONS]: {
    path: LazoPaths.PORTAL_NOTIFICATIONS,
    buildRoute: () => LazoPaths.PORTAL_NOTIFICATIONS,
    buildState: () => {},
  },
  [LazoRoutes.PORTAL_CUSTOMERS_DETAILS]: {
    path: LazoPaths.PORTAL_CUSTOMERS_DETAILS,
    buildRoute: () => LazoPaths.PORTAL_CUSTOMERS_DETAILS,
    buildState: () => {},
  },
  [LazoRoutes.FUNDER_LIST_DETAIL]: {
    path: LazoPaths.FUNDER_LIST_DETAIL,
    buildRoute: () => LazoPaths.FUNDER_LIST_DETAIL,
    buildState: () => {},
  },
  [LazoRoutes.PORTAL_INBOX]: {
    path: LazoPaths.PORTAL_INBOX,
    buildRoute: () => LazoPaths.PORTAL_INBOX,
    buildState: () => {},
  },
  [LazoRoutes.PORTAL_TAX_TIMELINE]: {
    path: LazoPaths.PORTAL_TAX_TIMELINE,
    buildRoute: () => LazoPaths.PORTAL_TAX_TIMELINE,
    buildState: () => {},
  },
  [LazoRoutes.INVITATION_COMPANY]: {
    path: LazoPaths.INVITATION_COMPANY,
    buildRoute: () => LazoPaths.INVITATION_COMPANY,
    buildState: () => {},
  },
  [LazoRoutes.ONE_SETTINGS]: {
    path: LazoPaths.ONE_SETTINGS,
    buildRoute: () => LazoPaths.ONE_SETTINGS,
    buildState: () => {},
  },
  [LazoRoutes.CHECKOUT]: {
    path: LazoPaths.CHECKOUT,
    buildRoute: () => LazoPaths.CHECKOUT,
    buildState: () => {},
  },
  [LazoRoutes.ONE_COMPANY_ADD]: {
    path: LazoPaths.ONE_COMPANY_ADD,
    buildRoute: () => LazoPaths.ONE_COMPANY_ADD,
    buildState: () => {},
  },
  [LazoRoutes.ONE_TASK_DETAILS]: {
    path: LazoPaths.ONE_TASK_DETAILS,
    buildRoute: () => LazoPaths.ONE_TASK_DETAILS,
    buildState: () => {},
  },
  [LazoRoutes.VERIFY_EMAIL]: {
    path: LazoPaths.VERIFY_EMAIL,
    buildRoute: () => LazoPaths.VERIFY_EMAIL,
    buildState: () => {},
  },
  [LazoRoutes.VERIFYING_EMAIL]: {
    path: LazoPaths.VERIFYING_EMAIL,
    buildRoute: () => LazoPaths.VERIFYING_EMAIL,
    buildState: () => {},
  },
  [LazoRoutes.REGISTER_USER_FOR_COMPANY]: {
    path: LazoPaths.REGISTER_USER_FOR_COMPANY,
    buildRoute: () => LazoPaths.REGISTER_USER_FOR_COMPANY,
    buildState: () => {},
  },
  [LazoRoutes.PERSONAL_INFORMATION]: {
    path: LazoPaths.PERSONAL_INFORMATION,
    buildRoute: () => LazoPaths.PERSONAL_INFORMATION,
    buildState: () => {},
  },
  [LazoRoutes.FORGOT_PASSWORD]: {
    path: LazoPaths.FORGOT_PASSWORD,
    buildRoute: () => LazoPaths.FORGOT_PASSWORD,
    buildState: () => {},
  },
  [LazoRoutes.FORGOT_PASSWORD_EMAIL_SENT]: {
    path: LazoPaths.FORGOT_PASSWORD_EMAIL_SENT,
    buildRoute: () => LazoPaths.FORGOT_PASSWORD_EMAIL_SENT,
    buildState: () => {},
  },
  [LazoRoutes.RESET_PASSWORD]: {
    path: LazoPaths.RESET_PASSWORD,
    buildRoute: () => LazoPaths.RESET_PASSWORD,
    buildState: () => {},
  },
  [LazoRoutes.NOT_SUPPORTED]: {
    path: LazoPaths.NOT_SUPPORTED,
    buildRoute: () => LazoPaths.NOT_SUPPORTED,
    buildState: () => {},
  },
  [LazoRoutes.PRODUCT_MANAGER]: {
    path: LazoPaths.PRODUCT_MANAGER,
    buildRoute: () => LazoPaths.PRODUCT_MANAGER,
    buildState: () => {},
  },
  [LazoRoutes.PRODUCT_FLOW_TASKS]: {
    path: LazoPaths.PRODUCT_FLOW_TASKS,
    buildRoute: () => LazoPaths.PRODUCT_FLOW_TASKS,
    buildState: () => {},
  },
  [LazoRoutes.PRODUCT_FLOW_TASKS_V2]: {
    path: LazoPaths.PRODUCT_FLOW_TASKS_V2,
    buildRoute: () => LazoPaths.PRODUCT_FLOW_TASKS_V2,
    buildState: () => {},
  },
  [LazoRoutes.PRODUCT]: {
    path: LazoPaths.PRODUCT,
    buildRoute: () => LazoPaths.PRODUCT,
    buildState: () => {},
  },
  [LazoRoutes.ONE_COMMUNICATIONS]: {
    path: LazoPaths.ONE_COMMUNICATIONS,
    buildRoute: () => LazoPaths.ONE_COMMUNICATIONS,
    buildState: () => {},
  },
  [LazoRoutes.PORTAL_SETTINGS]: {
    path: LazoPaths.PORTAL_SETTINGS,
    buildRoute: () => LazoPaths.PORTAL_SETTINGS,
    buildState: () => {},
  },
  [LazoRoutes.ONE_DOCUMENT_CENTER]: {
    path: LazoPaths.ONE_DOCUMENT_CENTER,
    buildRoute: () => LazoPaths.ONE_DOCUMENT_CENTER,
    buildState: () => {},
  },
  [LazoRoutes.PORTAL_DOCUMENT_CENTER]: {
    path: LazoPaths.PORTAL_DOCUMENT_CENTER,
    buildRoute: () => LazoPaths.PORTAL_DOCUMENT_CENTER,
    buildState: () => {},
  },
  [LazoRoutes.LAZO_TEAM]: {
    path: LazoPaths.LAZO_TEAM,
    buildRoute: () => LazoPaths.LAZO_TEAM,
    buildState: () => {},
  },
  [LazoRoutes.LAZO_TEAM_DETAILS]: {
    path: LazoPaths.LAZO_TEAM_MEMBER_DETAILS,
    buildRoute: () => LazoPaths.LAZO_TEAM_MEMBER_DETAILS,
    buildState: () => {},
  },
  [LazoRoutes.PORTAL_CUSTOMERS_ACCOUNTING]: {
    path: LazoPaths.PORTAL_CUSTOMERS_ACCOUNTING,
    buildRoute: () => LazoPaths.PORTAL_CUSTOMERS_ACCOUNTING,
    buildState: () => {},
  },
  [LazoRoutes.CSV_IMPORT_TOOL]: {
    path: LazoPaths.CSV_IMPORT_TOOL,
    buildRoute: () => LazoPaths.CSV_IMPORT_TOOL,
    buildState: () => {},
  },
  [LazoRoutes.ONE_DATA_ROOM]: {
    path: LazoPaths.ONE_DATA_ROOM,
    buildRoute: () => LazoPaths.ONE_DATA_ROOM,
    buildState: () => {},
  },
  [LazoRoutes.ONE_VIRTUAL_DATA_ROOMS]: {
    path: LazoPaths.ONE_VIRTUAL_DATA_ROOMS,
    buildRoute: () => LazoPaths.ONE_VIRTUAL_DATA_ROOMS,
    buildState: () => {},
  },
  [LazoRoutes.ONE_DATA_ROOM_FILES]: {
    path: LazoPaths.ONE_DATA_ROOM_FILES,
    buildRoute: () => LazoPaths.ONE_DATA_ROOM_FILES,
    buildState: () => {},
  },
  [LazoRoutes.LOG_ME_AS]: {
    path: LazoPaths.LOG_ME_AS,
    buildRoute: () => LazoPaths.LOG_ME_AS,
    buildState: () => {},
  },
  [LazoRoutes.ADMIN_TOOLS]: {
    path: LazoPaths.ADMINT_TOOLS,
    buildRoute: () => LazoPaths.ADMINT_TOOLS,
    buildState: () => {},
  },
  [LazoRoutes.VIRTUAL_ROOM_ANALYTICS]: {
    path: LazoPaths.VIRTUAL_ROOM_ANALYTICS,
    buildRoute: () => LazoPaths.VIRTUAL_ROOM_ANALYTICS,
    buildState: () => {},
  },
  [LazoRoutes.ONE_VIRTUAL_DATA_ROOMS_CREATE]: {
    path: LazoPaths.ONE_VIRTUAL_DATA_ROOMS_CREATE,
    buildRoute: () => LazoPaths.ONE_VIRTUAL_DATA_ROOMS_CREATE,
    buildState: () => {},
  },
  [LazoRoutes.ONE_VIRTUAL_DATA_ROOMS_INSIDE]: {
    path: LazoPaths.ONE_VIRTUAL_DATA_ROOMS_INSIDE,
    buildRoute: () => LazoPaths.ONE_VIRTUAL_DATA_ROOMS_INSIDE,
    buildState: () => {},
  },
  [LazoRoutes.SHARE_BY_LINK]: {
    path: LazoPaths.SHARE_BY_LINK,
    buildRoute: () => LazoPaths.SHARE_BY_LINK,
    buildState: () => {},
  },
  [LazoRoutes.SHARED_VIRTUAL_DATA_ROOM]: {
    path: LazoPaths.SHARED_VIRTUAL_DATA_ROOM,
    buildRoute: () => LazoPaths.SHARED_VIRTUAL_DATA_ROOM,
    buildState: () => {},
  },
  [LazoRoutes.HOME]: {
    path: LazoPaths.HOME,
    buildRoute: () => LazoPaths.HOME,
    buildState: () => {},
  },
  [LazoRoutes.SPENDING]: {
    path: LazoPaths.SPENDING,
    buildRoute: () => LazoPaths.SPENDING,
    buildState: () => {},
  },
  [LazoRoutes.ONE_SPENDING_DETAILS]: {
    path: LazoPaths.ONE_SPENDING_DETAILS,
    buildRoute: () => LazoPaths.ONE_SPENDING_DETAILS,
    buildState: () => {},
  },
  [LazoRoutes.SIGNUP]: {
    path: LazoPaths.SIGNUP,
    buildRoute: () => LazoPaths.SIGNUP,
    buildState: () => {},
  },
  [LazoRoutes.SIGNUP_COUNTRY_SELECT]: {
    path: LazoPaths.SIGNUP_COUNTRY_SELECT,
    buildRoute: () => LazoPaths.SIGNUP_COUNTRY_SELECT,
    buildState: () => {},
  },
  [LazoRoutes.SIGNUP_COMPANY]: {
    path: LazoPaths.SIGNUP_COMPANY,
    buildRoute: () => LazoPaths.SIGNUP_COMPANY,
    buildState: () => {},
  },
  [LazoRoutes.SIGNUP_COMPANY_INCORPORATION]: {
    path: LazoPaths.SIGNUP_COMPANY_INCORPORATION,
    buildRoute: () => LazoPaths.SIGNUP_COMPANY_INCORPORATION,
    buildState: () => {},
  },
  [LazoRoutes.SIGNUP_INDIVIDUAL]: {
    path: LazoPaths.SIGNUP_INDIVIDUAL,
    buildRoute: () => LazoPaths.SIGNUP_INDIVIDUAL,
    buildState: () => {},
  },
  [LazoRoutes.SIGNUP_COMPANY_INFO]: {
    path: LazoPaths.SIGNUP_COMPANY_INFO,
    buildRoute: () => LazoPaths.SIGNUP_COMPANY_INFO,
    buildState: () => {},
  },
  [LazoRoutes.SIGNUP_ACCOUNT_TYPE]: {
    path: LazoPaths.SIGNUP_ACCOUNT_TYPE,
    buildRoute: () => LazoPaths.SIGNUP_ACCOUNT_TYPE,
    buildState: () => {},
  },
  [LazoRoutes.SIGNUP_COMPANY_CONNECT]: {
    path: LazoPaths.SIGNUP_COMPANY_CONNECT,
    buildRoute: () => LazoPaths.SIGNUP_COMPANY_CONNECT,
    buildState: () => {},
  },
  [LazoRoutes.SHARED_CHECK_EMAIL]: {
    path: LazoPaths.SHARED_CHECK_EMAIL,
    buildRoute: () => LazoPaths.SHARED_CHECK_EMAIL,
    buildState: () => {},
  },
  [LazoRoutes.ROOM_EXPIRED]: {
    path: LazoPaths.ROOM_EXPIRED,
    buildRoute: () => LazoPaths.ROOM_EXPIRED,
    buildState: () => {},
  },
  [LazoRoutes.SHARED_FOR_LOGIN]: {
    path: LazoPaths.SHARED_FOR_LOGIN,
    buildRoute: () => LazoPaths.SHARED_FOR_LOGIN,
    buildState: () => {},
  },
  [LazoRoutes.ONE_VIRTUAL_DATA_ROOMS_FILE]: {
    path: LazoPaths.ONE_VIRTUAL_DATA_ROOMS_FILE,
    buildRoute: () => LazoPaths.ONE_VIRTUAL_DATA_ROOMS_FILE,
    buildState: () => {},
  },
  [LazoRoutes.VIRTUAL_DATA_ROOM_FINANCIAL_REPORT]: {
    path: LazoPaths.VIRTUAL_DATA_ROOM_FINANCIAL_REPORT,
    buildRoute: () => LazoPaths.VIRTUAL_DATA_ROOM_FINANCIAL_REPORT,
    buildState: () => {},
  },
  [LazoRoutes.SHARED_VIRTUAL_DATA_ROOM_FINANCIAL_REPORT]: {
    path: LazoPaths.SHARE_VIRTUAL_DATA_ROOM_FINANCIAL_REPORT,
    buildRoute: () => LazoPaths.SHARE_VIRTUAL_DATA_ROOM_FINANCIAL_REPORT,
    buildState: () => {},
  },
  [LazoRoutes.SHARED_VIRTUAL_DATA_ROOMS_FILE]: {
    path: LazoPaths.SHARED_VIRTUAL_DATA_ROOMS_FILE,
    buildRoute: () => {},
    buildState: () => {},
  },
  [LazoRoutes.REDIRECT]: {
    path: LazoPaths.REDIRECT,
    buildRoute: () => {},
    buildState: () => {},
  },
  [LazoRoutes.ONE_PAYWALL_CHOOSE_PLAN]: {
    path: LazoPaths.ONE_PAYWALL_CHOOSE_PLAN,
    buildRoute: () => {},
    buildState: () => {},
  },
  [LazoRoutes.ONE_PAYWALL]: {
    path: LazoPaths.ONE_PAYWALL,
    buildRoute: () => {},
    buildState: () => {},
  },
  [LazoRoutes.ONE_PAYWALL_SELECT_ADD_ONS]: {
    path: LazoPaths.ONE_PAYWALL_SELECT_ADD_ONS,
    buildRoute: () => {},
    buildState: () => {},
  },
  [LazoRoutes.ONE_PAYWALL_ADD_BILLING_DETAILS]: {
    path: LazoPaths.ONE_PAYWALL_ADD_BILLING_DETAILS,
    buildRoute: () => LazoPaths.ONE_PAYWALL_ADD_BILLING_DETAILS,
    buildState: () => {},
  },
  [LazoRoutes.ONE_PAYWALL_CONFIRM_PURCHASE]: {
    path: LazoPaths.ONE_PAYWALL_CONFIRM_PURCHASE,
    buildRoute: () => LazoPaths.ONE_PAYWALL_CONFIRM_PURCHASE,
    buildState: () => {},
  },
  [LazoRoutes.ONE_SIGNUP]: {
    path: LazoPaths.ONE_SIGNUP,
    buildRoute: () => LazoPaths.ONE_SIGNUP,
    buildState: () => {},
  },
  [LazoRoutes.DOCUMENT_MANAGER]: {
    path: LazoPaths.DOCUMENT_MANAGER,
    buildRoute: () => LazoPaths.DOCUMENT_MANAGER,
    buildState: () => {},
  },
  [LazoRoutes.SEARCH_AND_REPORTING]: {
    path: LazoPaths.SEARCH_AND_REPORTING,
    buildRoute: () => LazoPaths.SEARCH_AND_REPORTING,
    buildState: () => {},
  },
  [LazoRoutes.ORG_CHART]: {
    path: LazoPaths.ORG_CHART,
    buildRoute: () => LazoPaths.ORG_CHART,
    buildState: () => {},
  },
  [LazoRoutes.WORKFLOW_TEMPLATES]: {
    path: LazoPaths.WORKFLOW_TEMPLATES,
    buildRoute: () => LazoPaths.WORKFLOW_TEMPLATES,
    buildState: () => {},
  },
  [LazoRoutes.MY_SERVICES]: {
    path: LazoPaths.MY_SERVICES,
    buildRoute: () => LazoPaths.MY_SERVICES,
    buildState: () => {},
  },
  [LazoRoutes.MY_COMPANIES]: {
    path: LazoPaths.MY_COMPANIES,
    buildRoute: () => LazoPaths.MY_COMPANIES,
    buildState: () => {},
  },
  [LazoRoutes.MY_SERVICES_WORKFLOW_DETAIL]: {
    path: LazoPaths.ONE_MY_SERVICES_WORKFLOW_DETAIL,
    buildRoute: (id: string) => `/one/my-services/workflow/${id}`,
    buildState: () => {},
  },
  [LazoRoutes.TOOLS]: {
    path: LazoPaths.TOOLS,
    buildRoute: () => LazoPaths.TOOLS,
    buildState: () => {},
  },
  [LazoRoutes.TOOLS_BATCH_EMAIL]: {
    path: LazoPaths.TOOLS_BATCH_EMAIL,
    buildRoute: () => LazoPaths.TOOLS_BATCH_EMAIL,
    buildState: () => {},
  },
  [LazoRoutes.TOOLS_BULK_DOC_UPLOAD]: {
    path: LazoPaths.TOOLS_BULK_DOC_UPLOAD,
    buildRoute: () => LazoPaths.TOOLS_BULK_DOC_UPLOAD,
    buildState: () => {},
  },
  [LazoRoutes.TOOLS_BULK_FUP]: {
    path: LazoPaths.TOOLS_BULK_FUP,
    buildRoute: () => LazoPaths.TOOLS_BULK_FUP,
    buildState: () => {},
  },
  [LazoRoutes.TOOLS_CHANGE_PASSWORD]: {
    path: LazoPaths.TOOLS_CHANGE_PASSWORD,
    buildRoute: () => LazoPaths.TOOLS_CHANGE_PASSWORD,
    buildState: () => {},
  },
};

type BaseProjectNavigateOptions<T> = T extends undefined ? Omit<NavigateOptions, "state"> : Omit<NavigateOptions, "state"> & { state: T };

type NavigationProps = {
  [EnumKey in LazoRoutes]: Parameters<(typeof lazoRoutesSpecification)[EnumKey]["buildRoute"]>[0] extends undefined
    ? Parameters<(typeof lazoRoutesSpecification)[EnumKey]["buildState"]>[0] extends undefined
      ? {
          options?: BaseProjectNavigateOptions<Parameters<(typeof lazoRoutesSpecification)[EnumKey]["buildState"]>[0]>;
          navigate: NavigateFunction;
        }
      : {
          options: BaseProjectNavigateOptions<Parameters<(typeof lazoRoutesSpecification)[EnumKey]["buildState"]>[0]>;
          navigate: NavigateFunction;
        }
    : Parameters<(typeof lazoRoutesSpecification)[EnumKey]["buildState"]>[0] extends undefined
      ? {
          params: Parameters<(typeof lazoRoutesSpecification)[EnumKey]["buildRoute"]>[0];
          options?: BaseProjectNavigateOptions<Parameters<(typeof lazoRoutesSpecification)[EnumKey]["buildState"]>[0]>;
          navigate: NavigateFunction;
        }
      : {
          params: Parameters<(typeof lazoRoutesSpecification)[EnumKey]["buildRoute"]>[0];
          options: BaseProjectNavigateOptions<Parameters<(typeof lazoRoutesSpecification)[EnumKey]["buildState"]>[0]>;
          navigate: NavigateFunction;
        };
};

export function baseProjectNavigate<T extends LazoRoutes>(route: T, props: NavigationProps[T]) {
  if ("params" in props) {
    // @ts-ignore
    props.navigate(lazoRoutesSpecification[route].buildRoute(props.params as any), props.options);
  } else {
    props.navigate((lazoRoutesSpecification[route].buildRoute as any)(), props.options);
  }
}
